import { useQuery } from '@tanstack/react-query'
import { 
  getListAnnouncement
} from "./api"

export const useGetListAnnouncement = () => {
  return useQuery({
    queryKey: ['get-list-announcement'],
    queryFn: () => getListAnnouncement(),
  })
}
